export default __webpack_public_path__ + "static/media/Moran.d964d871.png";